import React, { useState } from 'react';
import { func, object } from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import {
    downloadGatewayManagerTool,
    downloadSoftwareAgentContainer,
    provisionSoftwareAgent
} from '../../actions/basAgentActions';

import {
    downloadErpAgentInstaller
} from '../../actions/erpAgentActions';

import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';

import classes from './DownloadsTableRowMenu.module.css';

const DownloadsTableRowMenu = ({
    companyInfo,
    isBasAgentDownload,
    isErpAgentInstallerDownload,
    isGatewayManagerDownload,
    history,
    location,
    downloadErpAgentInstaller,
    downloadGatewayManagerTool,
    downloadSoftwareAgentContainer,
    provisionSoftwareAgent
}) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    function handleOpen(event) {
        setAnchorEl(event.currentTarget);
    }

    function handleClose() {
        setAnchorEl(null);
    }

    function handleDownloadErpAgentInstaller() {
        downloadErpAgentInstaller();
        handleClose();
    }

    function handleDownloadGatewayManager() {
        downloadGatewayManagerTool();
        handleClose();
    }

    function handleDownloadSoftwareBasAgent() {
        let fileType = 'zip';
        downloadSoftwareAgentContainer(fileType);
        handleClose();
    }

    function handleGenerateCreds() {
        provisionSoftwareAgent(companyInfo.companyId);
        handleClose();
    }

    return (
        <React.Fragment>
            <Button
                aria-haspopup="true"
                onClick={handleOpen}
                className={classes.contextMenuButton}
            >
                <i className="fas fa-ellipsis-h" />
            </Button>
            <Menu
                id="render-props-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                className={classes.contextMenu}
            >
                {
                    isGatewayManagerDownload &&
                    <MenuItem
                        data-test-id="handleDownloadGatewayManager"
                        onClick={handleDownloadGatewayManager}
                    >
                        <img
                            alt=""
                            className={classes.contextIcon}
                            src="/assets/images/download-zip.svg"
                        />
                        Download .zip
                    </MenuItem>
                }
                {
                    isBasAgentDownload &&
                        <div className={classes.contextButtons}>
                            <MenuItem
                                data-test-id="handleDownloadSoftwareBasAgent"
                                onClick={handleDownloadSoftwareBasAgent}
                            >
                                <img
                                    alt=""
                                    className={classes.contextIcon}
                                    src="/assets/images/download-zip.svg"
                                />
                                Download .zip
                            </MenuItem>
                            <MenuItem
                                data-test-id="handleGenerateCreds"
                                onClick={handleGenerateCreds}
                            >
                                <img
                                    alt=""
                                    className={classes.contextIcon}
                                    src="/assets/images/download-credentials.svg"
                                />
                                Generate Creds
                            </MenuItem>
                        </div>
                }
                {
                    isErpAgentInstallerDownload &&
                        <div className={classes.contextButtons}>
                            <MenuItem
                                data-test-id="handleDownloadErpAgentInstaller"
                                onClick={handleDownloadErpAgentInstaller}
                            >
                                <img
                                    alt=""
                                    className={classes.contextIcon}
                                    src="/assets/images/download-zip.svg"
                                />
                                Download
                            </MenuItem>
                        </div>
                }
            </Menu>
        </React.Fragment>
    );
};

DownloadsTableRowMenu.defaultProps = {
    downloadErpAgentInstaller:      () => { },
    downloadGatewayManagerTool:     () => { },
    downloadSoftwareAgentContainer: () => { },
    provisionSoftwareAgent:         () => { }
};

DownloadsTableRowMenu.propTypes = {
    companyInfo:                object,
    downloadErpAgentInstaller:  func,
    downloadGatewayManagerTool: func,
    provisionSoftwareAgent:     func
};

const mapDispatchToProps = {
    downloadErpAgentInstaller,
    downloadGatewayManagerTool,
    downloadSoftwareAgentContainer,
    provisionSoftwareAgent
};

export default withRouter(
    connect(null, mapDispatchToProps)(DownloadsTableRowMenu)
);
